import { featureFlipping, Locale, Scope } from '@headless-workspace/config';
import { ServerErrorCode } from '@headless-workspace/data';
import { CommonDI, LoggerType } from '@headless-workspace/domain/common/DI';
import { PageManager, RootPageManager, RootPageParams } from '@headless-workspace/domain/common/server';
import { getMemoNewsletterSlot } from '../newsletter/getMemoNewsletterSlot';
import { HomeSlotType } from './HomeSlotType';
import { getMemoHomeSlots, ReconciledHomeSlotsValue } from './getMemoHomeSlots';

type HomePageParams = Partial<{ slots: ReconciledHomeSlotsValue }> & RootPageParams;

type HomePreloadParams = {
    locale: Locale;
};

const REQUIRED_SLOTS = [
    HomeSlotType.MainBanner,
    // ProductRecommendations slot is commented as this slot is missing for some locales like da-DK
    // HomeSlotType.ProductRecommendations,
    HomeSlotType.TargetedCarousel,
];
export const HomePageManager: PageManager<HomePageParams, HomePreloadParams> = {
    canGeneratePage({ slots, ...rootParams }: HomePageParams): boolean {
        const hasRequiredSlots = featureFlipping.isHomeSlotsFailoverCheckDisabled
            ? true
            : !!slots && REQUIRED_SLOTS.every((slotType) => slots.find((slot) => slot.type === slotType));

        return RootPageManager.canGeneratePage(rootParams) && hasRequiredSlots;
    },

    preloadPageData({ locale }: HomePreloadParams): void {
        Promise.allSettled([
            // All Home Page preload functions should be added here
            getMemoHomeSlots(locale),
            getMemoNewsletterSlot(locale),
        ]).catch((error) => {
            CommonDI.get(LoggerType).error(ServerErrorCode.PagePreload, Scope.HomePage, error);
        });
    },
};
